import { IMediaItem } from 'modules/media/interfaces/api';
import { useCallback } from 'react';
import mediaApis from '../apis';
import { getMessageError } from 'services/response';
import toast from 'utils/toast';

type UseDeleteMediaItemProps = {
  currentPath: string;
  onSuccess: (currentPath: string) => void;
  deleteSuccess?: () => void;
};
  
export const useDeleteMediaItem = ({ currentPath, onSuccess, deleteSuccess }: UseDeleteMediaItemProps) => {

  const deleteItem = useCallback(
    async (item: IMediaItem) => {
      try {
        const res = await mediaApis.deleteMediaItem(item.id);

        if (res?.data) {
          toast.success('Deleted successfully.');
          onSuccess(currentPath);
          deleteSuccess?.();
        }
      } catch (error) {
        toast.error(getMessageError(error) || 'An error occurred while deleting the item.');
      }
    },
    [onSuccess, currentPath]
  );

  return { deleteItem };
};
